import { defineStore } from 'pinia';
import { ref } from 'vue';

type Refresher = () => void;

// 模块级单例：避开 Pinia 把 ref(Set) 包成 reactive Proxy 后的多实例/HMR 风险
const tableRefreshers = new Set<Refresher>();

// 部门数据筛选 — 全局状态 + 表格刷新注册表
export const useDepartmentFilterStore = defineStore('departmentFilter', () => {
  const selectedDepartmentIds = ref<(number | string)[]>([]);
  const filterTick = ref(0);
  const lastFilterResult = ref<any[]>([]);

  function registerTableRefresh(fn: Refresher) {
    tableRefreshers.add(fn);
  }

  function unregisterTableRefresh(fn: Refresher) {
    tableRefreshers.delete(fn);
  }

  function notifyAllTablesRefresh() {
    tableRefreshers.forEach((fn) => {
      try {
        fn();
      } catch (e) {
        // 单个表格刷新失败不影响其它
      }
    });
  }

  function applyFilter(ids: (number | string)[], result: any[] = []) {
    selectedDepartmentIds.value = ids;
    lastFilterResult.value = result;
    filterTick.value += 1;
    notifyAllTablesRefresh();
  }

  function clearFilter() {
    selectedDepartmentIds.value = [];
    lastFilterResult.value = [];
    filterTick.value += 1;
    notifyAllTablesRefresh();
  }

  return {
    selectedDepartmentIds,
    filterTick,
    lastFilterResult,
    registerTableRefresh,
    unregisterTableRefresh,
    notifyAllTablesRefresh,
    applyFilter,
    clearFilter,
  };
});
